<template>
  <div class="fullPage" ref="fullPage">
    <div class="fullPageContainer" ref="fullPageContainer">
      <div
        class="section bannerClass"
        :style="{ backgroundImage: `url(${imgUrl})` }"
      >
        <div
          class="main_content space_between pro2_content first_content"
          v-if="activeName == 'first'"
        >
          <div class="title_wrap">
            <p class="title">
              小鳗管家
            </p>
            <img src="../../assets/line.png" alt="" class="title_line" />
            <p class="title2">SMALLEEL PLATFORM</p>
            <p class="title_str">
              小鳗管家是四川辰鳗科技有限公司旗下专注于商业楼宇能源数字化管理的品牌，重点涵盖能源管理系统、计量收费系统、动力储能回馈系统、暖通空调节能算法控制系统四大业务板块。专业为商业综合体、产业园区、专业市场、公寓、写字楼等商业楼体提供数字化智能监测、智能收费、一站式全无线专业解决方案。
            </p>
            <div
              style="margin-top: 59px; font-family: 'Light';"
              class="banner_btn"
              @click="handleSelect"
            >
              我要咨询
            </div>
          </div>
          <div class="first_imgWrap">
            <img src="../../assets/pro_model.png" alt="" class="pro_model" />
          </div>
        </div>

        <div class="main_content pro2_content" v-if="activeName == 'second'">
          <div class="user_wrap1">
            <div class="title_wrap">
              <p class="title">
                用户价值
              </p>
              <img src="../../assets/line.png" alt="" class="title_line" />
              <p class="title2">USER VALUE</p>
            </div>

            <div class="pro2_user1 card">
              <div class="paragraph">
                <div class="h1">
                  <span class="left_line"></span>
                  <span class="ml12">数字化能耗管理</span>
                </div>
                <div class="h2 mt18 ml20">
                  预付费收费、节能监管、能耗分析、电量、水表集采系统
                </div>
              </div>
            </div>

            <div class="pro2_user2 card">
              <div class="paragraph">
                <div class="h1">
                  <span class="left_line"></span>
                  <span class="ml12">智能化的多级远程管控</span>
                </div>
                <div class="h2 mt18 ml20">
                  树状管理结构，设备运行监控、异常报警，支持角色分配、客服收费、工程管理
                </div>
              </div>
            </div>
          </div>

          <div class="user_wrap2">
            <div class="pro2_user3 card">
              <div class="paragraph">
                <div class="h1">
                  <span class="left_line"></span>
                  <span class="ml12">综合性的财务支持</span>
                </div>
                <div class="h2 mt18 ml20">
                  电费缴纳限制，支持其它类型收费，自动数据报表
                </div>
              </div>
            </div>

            <div class="pro2_user4 card">
              <div class="paragraph">
                <div class="h1">
                  <span class="left_line"></span>
                  <span class="ml12">零试错成本</span>
                </div>
                <div class="h2 mt18 ml20">
                  免费提供硬件、软件，先施工、先落地、后收费
                </div>
              </div>
            </div>

            <div class="pro2_user5 card2">
              <div class="paragraph"></div>
            </div>
          </div>
        </div>

        <div
          class="main_content space_between third_content"
          v-if="activeName == 'third'"
        >
          <div class="pro2_content title_wrap">
            <p class="title">
              应用场景
            </p>
            <img src="../../assets/line.png" alt="" class="title_line" />
            <p class="title2">APPLICATION SCENARIOS</p>
            <p class="title_str">
              针对不同建筑楼宇类型，实现智能化系统大集成、能耗量化分析、冷热源控制、智能运维系统，在设备台账、设备巡检、智能工单、维保计划、绩效管理、空气品质决策控制等方面业务的落地。
            </p>
          </div>
          <div class="third_imgWrap">
            <img src="../../assets/pro2_scene.png" alt="" class="pro_scene" />
          </div>
        </div>

        <div class="main_content" v-if="activeName == 'fourth'">
          <div class="point_wrap1">
            <div class="title_wrap">
              <p class="title">
                功能亮点
              </p>
              <img src="../../assets/line.png" alt="" class="title_line" />
              <p class="title2">FUNCTION HIGHLIGHTS</p>
            </div>
            <div class="flex">
              <div
                :class="lightType == 1 ? 'h_light2' : 'h_light1'"
                @click="handleChange(1)"
              >
                硬件功能亮点
              </div>
              <div
                :class="lightType == 2 ? 'h_light2' : 'h_light1'"
                @click="handleChange(2)"
              >
                软件功能亮点
              </div>
            </div>
          </div>
          <ul class="light_ul mt60" v-if="lightType == 1">
            <li
              v-for="(item, index) in lightArr"
              :key="index"
              class="flex"
              :style="{
                backgroundImage: `url(${item.bg})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover'
              }"
            >
              <img :src="item.icon" alt="" class="light_icon" />
              <div class="tl">
                <p class="h1">{{ item.title }}</p>
                <p class="h2 mt16">{{ item.str }}</p>
              </div>
            </li>
          </ul>
          <ul class="light_ul2 mt60" v-if="lightType == 2">
            <li
              v-for="(item, index) in lightArr2"
              :key="index"
              class="flex_column"
            >
              <div class="light_ul2_top">
                <img :src="item.icon" alt="" class="light2_icon" />
                <div class="h1">{{ item.title }}</div>
                <img :src="item.icon2" alt="" />
              </div>
              <div class="h2 light_ul2_bottom">
                {{ item.str }}
              </div>
            </li>
          </ul>
        </div>
        <div class="main_content" v-if="activeName == 'five'">
          <div class="main_top">
            <div class="case_wrap">
              <p class="title">
                落地案例
              </p>
              <img src="../../assets/line.png" alt="" class="title_line" />
              <p class="title2">AFFILIATE CASE</p>
            </div>

            <div
              class="theSwiper"
            >
              <div class="leftArrow arrow">
                <i class="el-icon-back" @click="prevBtn"></i>
              </div>
              <swiper
                height="50px"
                ref="mySwiper"
                class="carousel"
                style="position: relative"
                :options="swiperOption"
              >
                <swiper-slide
                  v-for="(item, index) in swiperArr"
                  :key="index"
                  @click="changeTitle(index)"
                  class="carousel_title"
                >
                  {{ item.title }}
                </swiper-slide>
              </swiper>
              <div class="rightArrow arrow">
                <i class="el-icon-right" @click="nextBtn"></i>
              </div>
            </div>
          </div>
          <div class="carousel_content">
            <div class="content_item">
              <img :src="currentItem.img" alt="" class="content_img" />
              <div class="content_wrap">
                <p class="content_title">{{ currentItem.title }}</p>
                <p
                  v-for="(descList, index1) in currentItem.desc"
                  :key="index1"
                  class="content_desc"
                >
                  {{ descList }}
                </p>
                <div
                  class="banner_btn mt20"
                  @click="handleUrl(currentItem.url)"
                >
                  了解更多
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="tabs">
        <el-tabs v-model="activeName">
          <el-tab-pane label="首页" name="first"> </el-tab-pane>
          <el-tab-pane label="用户价值" name="second"></el-tab-pane>
          <el-tab-pane label="应用场景" name="third"></el-tab-pane>
          <el-tab-pane label="功能亮点" name="fourth"></el-tab-pane>
          <el-tab-pane label="落地案例" name="five"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  name: "Service",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    let that = this;
    return {
      swiperOption: {
        slidesPerView: 3, //一行显示3个
        spaceBetween: 20,
        initialSlide: 0, //默认第三页
        centeredSlides: true, //选中的swiper-slide显示在中间
        slideToClickedSlide: true, //可以点击切换
        speed: 1000, //滑动速度
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        loop: true,
        autoplay: {
          delay: 1000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        on: {
          slideChangeTransitionStart() {
            let ix = null;
            // 3-0 4-1 5-2 6-3 7-4 8-5 9-6 10-0 11-1
            // 因为一次显示3个，前后都会补图片，形成闭环切换
            if (this.activeIndex === 3 || this.activeIndex === 10) {
              ix = 0;
            } else if (this.activeIndex === 4 || this.activeIndex === 11) {
              ix = 1;
            } else {
              ix = this.activeIndex - 3;
            }
            that.curIndex = ix;
            // console.log(ix, "start");
          }
        }
      },
      curIndex: 0,
      activeName: "first",
      imgUrl: "https://file.smalleel.com/2023/08/28/1693186950buiLe.png",
      screenWidth: document.body.clientWidth,
      middle: 1,
      deviceData: [],
      simpleData: [],
      feedback: [],
      dbModelList: [],
      searchList: [],
      type: -1,
      expendStatus: false,
      productModel: "",
      lightArr: [
        {
          icon: require("../../assets/light_Icon1.png"),
          bg: require("../../assets/light_rect1.png"),
          title: "功能板块",
          str: "智能收费系统、能耗监测系统、节能管理系统。"
        },
        {
          icon: require("../../assets/light_Icon2.png"),
          bg: require("../../assets/light_rect2.png"),
          title: "设置功能",
          str: "定时开关设置，峰平谷电价、 阶梯电价、拉合闸控制。"
        },
        {
          icon: require("../../assets/light_Icon3.png"),
          bg: require("../../assets/light_rect3.png"),
          title: "主动保护功能",
          str: "额定电流过载保护、缺相指示、压线松动状态报警，窃电报警。"
        },
        {
          icon: require("../../assets/light_Icon4.png"),
          bg: require("../../assets/light_rect4.png"),
          title: "数据监测项",
          str:
            "电流、电压、功率因数、有功电量、无功电量、组合有功电量、 组合无功电量。"
        },
        {
          icon: require("../../assets/light_Icon5.png"),
          bg: require("../../assets/light_rect5.png"),
          title: "计量方式",
          str: "正向、反向、有功、无功计量。"
        },
        {
          icon: require("../../assets/light_Icon6.png"),
          bg: require("../../assets/light_rect6.png"),
          title: "收费方式",
          str: "预付费、后付费、可灵活设置收费模式。"
        }
      ],
      lightArr2: [
        {
          icon: require("../../assets/light2_Icon1.png"),
          icon2: require("../../assets/01.png"),
          bg: require("../../assets/light_rect1.png"),
          title: "智能化管理",
          str: "智能监控、智能分析、智能告警。"
        },
        {
          icon: require("../../assets/light2_Icon2.png"),
          icon2: require("../../assets/02.png"),
          bg: require("../../assets/light_rect2.png"),
          title: "一站式综合收费",
          str:
            "手机缴费，各类费用账单自动发送，无需人工送单；结合停电或限制缴电费，实现费用100%收缴率；各类财务报表自动生成且进行分析，支持Excel导出，实现财务溯源。 "
        },
        {
          icon: require("../../assets/light2_Icon3.png"),
          icon2: require("../../assets/03.png"),
          bg: require("../../assets/light_rect3.png"),
          title: "防窃电管理",
          str: "反接同步计量、预警表外窃电、人工智能推送。"
        },
        {
          icon: require("../../assets/light2_Icon4.png"),
          icon2: require("../../assets/04.png"),
          bg: require("../../assets/light_rect4.png"),
          title: "智能公摊",
          str:
            " 多种模型自动计算公摊、自动发送账单收取公摊、方案通过物价部门验收。"
        },
        {
          icon: require("../../assets/light2_Icon5.png"),
          icon2: require("../../assets/05.png"),
          bg: require("../../assets/light_rect5.png"),
          title: "线损分析",
          str:
            "通过分区、分片、分电压等进行线损统计，精细化管理；做好日\月\年度线损率数据可视图，掌握系统有功、无功潮流、电压等情况为制定节能方案提供依据。"
        },
        {
          icon: require("../../assets/light2_Icon6.png"),
          icon2: require("../../assets/06.png"),
          bg: require("../../assets/light_rect6.png"),
          title: "公区对比",
          str:
            "通过对公区重点设备进行实时监控、能耗时段分析等，管理者能够准确掌握能源成本比重和发展趋势，增加楼层、公区之间的环比。"
        },
        {
          icon: require("../../assets/light2_Icon7.png"),
          icon2: require("../../assets/07.png"),
          bg: require("../../assets/light_rect6.png"),
          title: "能耗数字化展示",
          str:
            "平台会将能耗数据进行统计分析，转换为可视化图表的形式，可以直观的看出每天\月\年的用电量、用电异常的时间段、正常用电、同比上月/年的变化、区域耗电量对比的规律等数据。"
        },
        {
          icon: require("../../assets/light2_Icon8.png"),
          icon2: require("../../assets/08.png"),
          bg: require("../../assets/light_rect6.png"),
          title: "智慧节能方案推送",
          str:
            "系统依据历史使用数据，自动制订有效可行的节能策略，降低运营成本，实现节能增效。如公区中央空调、电梯、公共照明、弱电系统等。"
        }
      ],
      swiperTitle: [],
      swiperArr: [
        {
          title: "重庆·金源时代购物中心",
          img: require("../../assets/cqjy.png"),
          desc: [
            "项目位于重庆市江北区观音桥正前方，重庆最具发展潜力的北滨路核心区金源大道路口，是世纪金源集团继成功打造观音桥地标项目金源大饭店后，在重庆的又一地标性建筑，总商业面积35万平方米。包含日用百货、大型超市、专业市场、家居卖场等多种业态。"
          ],
          url: "https://mp.weixin.qq.com/s/tvHmaBGxhL-IxdJn4_UBzw"
        },
        {
          img: require("../../assets/jn.png"),
          title: "济南IFC中央公馆",
          desc: [
            "济南IFC中央公馆位于济南市历下化纤厂路，总建筑面积16.4万㎡，共计房屋1444户。IFC中央公馆身处济南CBD，占整个CBD面积的1/4。业态分布主要为420米山东第一高楼办公、酒店、高端主题商业、新天地商业街、办公及高端住宅。项目开发分为五期。"
          ],
          url: "https://mp.weixin.qq.com/s/T-dGlrs_G0y04sW5E-wgeA"
        },
        {
          img: require("../../assets/xc.png"),
          title: "西昌唐园",
          desc: [
            "唐园坐落于四川省西昌市建昌东路，项目计划总投资7.78亿元，规划用地总面积约11万平方米，建筑总面积7万多平方米。该项目作为西昌市创建“省级公园城市”的重点文旅项目，是西昌深入挖掘历史文化、展示本地地域特色、拓展城市空间的重点体现。致力于打造成唐“潮”艺术生活街区，集文化旅游、商业为一体的综合性城市公园。"
          ],
          url: "https://mp.weixin.qq.com/s/c2BEpgaypMFExaH8lqCHmA"
        },
        {
          img: require("../../assets/gzhj.png"),
          title: "广州合景誉山国际",
          desc: [
            "合景誉山国际项目位于广州市增城区，总投资额约110亿元，建筑面积254万平方米，是集酒店、会展、购物城、写字楼、住宅于一身的3000亩大型综合体。合景誉山国际分五期开发，首期包括酒店、会展、购物、商业街、写字楼和住宅，建筑面积超过30万平方米。二期为纯别墅区，分南北两区，共有独栋、双拼等别墅。三期为洋房区。除此以外，小区周边规划有医院、国际学校、运动场馆、文化活动中心幼儿园、小学、中学等。"
          ],
          url: "https://mp.weixin.qq.com/s/aK6TEqwqus8B9y1-xVF1sA"
        },
        {
          img: require("../../assets/xa.png"),
          title: "西安富平新里城",
          desc: [
            "西安富平绿地新里城，位于西安市荆山大道与怀德大街交汇处。项目隶属于绿地集团新里系的高端产品系，它缘起新式里弄，中西合璧，充分结合了“传统，品质，人文，智慧”四大特质，打造高端人文社区，主要针对城市菁英。项目总占地228亩，总规划33万方、42栋楼，容积率低至1.8，分两个地块开发。产品含住宅、商业5300㎡及教育配套设施。"
          ],
          url: "https://mp.weixin.qq.com/s/MB0T00p7xizsLop5I_FnxA"
        },
        {
          img: require("../../assets/zd.png"),
          title: "中电建云立方",
          desc: [
            "云立方项目地处成都市龙泉驿区龙城大道816号，项目总占地128亩，项目住宅部分建筑面积38.2万平米，并配套4.1万平米建面商业，项目内还规划有幼儿园。"
          ],
          url: "https://mp.weixin.qq.com/s/QfYSSSAksVhnLmOBibBHeQ"
        },
        {
          img: require("../../assets/gzyh.png"),
          title: "广州永荟广场",
          desc: [
            "永荟广场项目位于广州东TOD国际交通枢纽附近（香山大道与创新大道交汇处），占地面积约21万㎡，总建面约75万㎡大型商业综合体。项目落成后将成为新塘开发区的商业核心圈，项目本身自带建面约23万㎡永旺梦乐城华南旗舰店，加上项目旁的新塘万达广场等商业，将为区域带来百万消费人群。"
          ],
          url: "https://mp.weixin.qq.com/s/2DkY2nsVtulyPSBoiqV9LA"
        }
      ],
      lightType: 1,
      curIndex: 0,
      timer: 1000,
      AutoSwiper: null,
      leftDown: false,
      rightDown: false
    };
  },
  computed: {
    titleWidth() {
      return this.swiperArr.length * 220 + "px";
    },
    boxLeft() {
      return -this.curIndex * 220 + "px";
    },
    currentItem() {
      return this.swiperArr[this.curIndex];
    },
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
  },
  methods: {
    prevBtn() {
      this.swiper.slidePrev();
    },
    nextBtn() {
      this.swiper.slideNext();
    },
    handleSelect() {
      this.$router.push({
        name: "aboutUs",
        params: {
          index: 5
        }
      });
    },
    changeTitle(index) {
      this.curIndex = index;
    },
    handleChange(type) {
      this.lightType = type;
    },
    handleUrl(url) {
      window.open(url, "_blank");
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/style/product.scss";

/*去掉el-tab-pane底部灰色线条*/
/deep/ .el-tabs__nav-wrap::after {
  height: 0 !important;
  background: transparent !important;
}
/*去掉el-tab-pane切换时的蓝色下划线*/
/deep/ .el-tabs__active-bar {
  background: transparent !important;
}

/deep/ .el-tabs__item.is-active {
  color: #3170ff;
}

/deep/ .el-tabs__nav {
  width: 100%;
  height: 60px;
  line-height: 60px;
  float: none;
  /* background: linear-gradient(90deg, rgba(52,56,59,0.99)); */
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.2) 0%,
    rgba(52, 56, 59, 0.2) 50%,
    rgba(0, 0, 0, 0.2) 100%
  );
  /* opacity: 0.6; */
}

/deep/ .el-tabs__item {
  padding: 0 35px;
  color: #ffffff;
  font-size: 14px;
  font-family: "Regular";
  opacity: 1 !important;
}
/deep/ .el-tabs__header {
  margin: 0;
}

.bannerClass {
  width: 100%;
  color: #ffffff;
  background-image: url("../../assets/service_bg1.png");
  background-position: center;
  background-size: cover;
  position: relative;
}
.tabs {
  position: fixed;
  bottom: 20px;
  text-align: center;
  margin: auto;
  width: 100%;
}

.main_content {
  z-index: 99;
  text-align: left;
  .title {
    font-size: 60px;
    font-family: "PangMenZhengDao";
    font-weight: 400;
    color: #ffffff;
    line-height: 1;
    letter-spacing: 4px;
  }
  .title_line {
    width: 230px;
    height: 8px;
    margin-top: 20px;
  }
  .title2 {
    font-size: 24px;
    font-family: "PangMenZhengDao";
    font-weight: 400;
    color: #ffffff;
    margin-top: 20px;
  }
  .title_str {
    width: 320px;
    font-size: 14px;
    font-family: "Light";
    font-weight: 300;
    color: #ffffff;
    line-height: 22px;
    margin-top: 58px;
  }
  .banner_btn {
    width: 120px;
    height: 32px;
    line-height: 32px;
    background: rgba(0, 0, 0, 0);
    border: 1px solid #ffffff;
    color: #fff;
    border-radius: 16px;
    text-align: center;
  }
}

.content2 {
  background-image: url("../../assets/service_bg2.png");
  background-position: center;
  background-size: cover;
}

.content3 {
  background-image: url("../../assets/service_bg3.png");
  background-position: center;
  background-size: cover;
}

.content4 {
  background-image: url("../../assets/service_bg4.png");
  background-position: center;
  background-size: cover;
}
.content5 {
  background-image: url("../../assets/service_bg5.png");
  background-position: center;
  background-size: cover;
}

.sub_title {
  text-align: left;
  /* padding-top: 150px; */
  display: flex;
  align-items: baseline;
  .div1 {
    font-size: 60px;
    font-family: "PangMenZhengDao";
    font-weight: 400;
  }
  .div2 {
    font-size: 24px;
    font-family: "PangMenZhengDao";
    font-weight: 400;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-left: 24px;
  }
  .line {
    display: block;
    width: 5px;
    height: 16px;
    background: #3170ff;
    margin-left: 10px;
  }
}

.plan_img {
  width: 778px;
  height: 368px;
  margin: auto;
  margin-top: 57px;
  margin-left: 202px;
}

.plan_ul {
  display: flex;
  margin-top: 32px;

  li {
    width: 320px;
    height: 120px;
    /* background: linear-gradient(-90deg, #3170FF); */
    opacity: 0.6;
  }
  .plan_title {
    font-size: 18px;
    font-family: "Regular";
    font-weight: 400;
  }

  .plan_str {
    font-size: 14px;
    font-family: "Light";
    font-weight: 300;
    color: #ffffff;
    line-height: 20px;
  }
}

.value_img {
  width: 826px;
  height: 560px;
  margin-left: 160px;
}
.pain_point {
  display: flex;
  flex-wrap: wrap;
  margin-top: 62px;
  li {
    width: 380px;
    height: 240px;
    text-align: center;
  }
  .p1 {
    margin-top: 127px;
    font-size: 18px;
    font-family: "Medium";
    font-weight: 500;
    color: #ffffff;
  }
  .p2 {
    margin-top: 18px;
    padding: 0 90px;
    line-height: 20px;
    font-size: 14px;
    font-family: "Light";
    font-weight: 300;
  }
}
.pro_model {
  width: 702px;
  height: 524px;
  padding-bottom: 122px;
}
.pro_scene {
  width: 820px;
  height: 620px;
  margin-top: 96px;
}

.card {
  width: 380px;
  height: 240px;
  position: relative;
}
.card::after {
  content: "";
  opacity: 0.7;
  background: linear-gradient(0deg, #34383b, #181a1c);
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.card2 {
  width: 240px;
  height: 120px;
  justify-items: baseline;
}
.paragraph {
  position: absolute;
  opacity: 1 !important;
  top: 100px;
  z-index: 2;
  opacity: 1;
  width: 230px;
  top: 40px;
  left: 20px;
}

.h1 {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-family: "Medium";
  font-weight: 500;
  color: #ffffff;
  line-height: 20px;
}
.h2 {
  font-size: 14px;
  font-family: "Light";
  font-weight: 300;
  color: #ffffff;
  line-height: 20px;
}
.pro2_user1 {
  background-image: url("../../assets/pro2_user1.png");
}

.pro2_user2 {
  background-image: url("../../assets/pro2_user2.png");
}

.pro2_user3 {
  background-image: url("../../assets/pro2_user3.png");
}

.pro2_user4 {
  background-image: url("../../assets/pro2_user4.png");
}

.pro2_user5 {
  background-image: url("../../assets/pro2_user5.png");
}

.h_light1 {
  width: 210px;
  height: 60px;
  line-height: 60px;
  background: url("../../assets/h_light1.png") no-repeat;
  background-size: cover;
  text-align: center;
}
.h_light2 {
  width: 210px;
  height: 60px;
  line-height: 60px;
  background: url("../../assets/h_light2.png") no-repeat;
  background-size: cover;
  text-align: center;
}

.light_ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.light_ul > li {
  width: 380px;
  height: 160px;
  justify-content: center;
  align-items: center;
}
.light_ul > li:not(:last-child) {
  margin-bottom: 30px;
}
.light_icon {
  width: 66px;
  height: 72px;
  margin: 0 30px;
}

.light_ul2 {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.light_ul2 > li {
  height: auto;
  align-items: flex-start;
  width: calc((100% - 20px) / 4);
  &:nth-child(4n + 4) {
    margin-right: 0;
  }
}
.light_ul2 > li:not(:last-child) {
  margin-bottom: 30px;
}
.light2_icon {
  width: 30px;
  height: 30px;
}
.light_ul2_top {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
}
.light_ul2_bottom {
  padding: 0 20px;
  margin-top: 7px;
}

.main_top {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.theSwiper {
  display: flex;
  .carousel {
    overflow: hidden;
    width: 650px;
    height: 50px;
  }
  .arrow {
    width: 40px;
    height: 50px;
    background: #232629;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
  }
  .carousel_item {
    display: flex;
    /* position: relative; */
  }
  .carousel_wrapper {
    position: relative;
    height: 50px;
    padding: 0;
    left: 0;
  }
  .carousel_title {
    float: left;
    width: 180px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #262a2d;
    margin: 0 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    /* position: absolute; */
  }
  >>>.swiper-slide-active {
    background: url("../../assets/aboutUs/item_bg.png") no-repeat;
    background-position: center;
    background-size: cover;
  }
}

.carousel_content {
  width: 100%;
  height: 400px;
  margin-top: 60px;
  display: flex;
}
.content_item {
  display: flex;
  height: 400px;
  align-items: center;
}
.content_wrap {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}
.content_title {
  font-size: 16px;
  font-family: "Medium";
  font-weight: 500;
  color: #ffffff;
  line-height: 20px;
  text-align: center;
}
.content_desc {
  font-size: 14px;
  font-family: "Regular";
  font-weight: 400;
  color: #ffffff;
  line-height: 22px;
  margin-top: 30px;
  text-indent: 28px;
  margin-left: 60px;
  margin-right: 60px;
}
.content_img {
  width: 800px;
  height: 400px;
}
.gray {
  opacity: 0.6;
}
.user_wrap1 {
  display: flex;
  justify-content: space-between;
}
.user_wrap2 {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-top: 30px;
}
.point_wrap1 {
  padding-top: 80px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.case_wrap {
  padding-top: 80px;
}
.pro2_content {
  padding-top: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/product_inlet2.vue